/**
 * API Services Export
 * Central export point for all API services
 */

// Export individual services
export { default as ibasService } from "./ibas.service";
export { default as brokerService } from "./broker.service";
export { default as locationService } from "./location.service";
export { default as niapService } from "./niap.service";
export { default as smsService } from "./sms.service";

// Export clients for advanced usage
export {
  ibasClient,
  brokerClient,
  locationClient,
  niapClient,
  otpClient,
  loadClient,
  smsClient,
} from "./client";

// Export Google API Key
export const googleApiKey = process.env.VUE_APP_GOOGLE_API_KEY;

// Default export for convenience
export default {
  ibas: require("./ibas.service").default,
  broker: require("./broker.service").default,
  location: require("./location.service").default,
  niap: require("./niap.service").default,
  sms: require("./sms.service").default,
};
